export interface HdmgdjPlatform {
  key: string;
  name: string;
  shortName: string;
  desc: string;
  note: string;
  icon: string;
  url: string;
}

export interface HdmgdjConfig {
  siteName: string;
  domain: string;
  logoLink: string;
  downloadUrl: string;
  contactEmail: string;
  version: string;
  updateDate: string;
  fileSize: string;
  platforms: HdmgdjPlatform[];
}

/**
 * 兜底配置：当外置 JSON（public/hdmgdj-config.json）读取失败时使用。
 * 正式数据以线上 JSON 为准，修改链接无需重新打包。
 */
export const hdmgdjDefaultConfig: HdmgdjConfig = {
  siteName: "黄豆魔改短剧",
  domain: "huangdoumogaiduanju.com",
  logoLink: "http://www.huangdoumogaiduanju.com",
  downloadUrl: "https://www.huangdoumogaiduanju.com",
  contactEmail: "txby666666@163.com",
  version: "V3.6.2",
  updateDate: "2026-09-30",
  fileSize: "189MB",
  platforms: [
    {
      key: "android",
      name: "Android 版",
      shortName: "Android",
      desc: "适配主流安卓机型，APK 一键安装",
      note: "支持 Android 6.0 及以上",
      icon: "ri-android-fill",
      url: "https://www.huangdoumogaiduanju.com",
    },
    {
      key: "ios",
      name: "iOS 版",
      shortName: "iOS",
      desc: "为 iPhone / iPad 深度优化，流畅顺滑",
      note: "支持 iOS 13.0 及以上",
      icon: "ri-apple-fill",
      url: "https://www.huangdoumogaiduanju.com",
    },
    {
      key: "harmony",
      name: "HarmonyOS 版",
      shortName: "HarmonyOS",
      desc: "原生鸿蒙适配，跨设备无缝续看",
      note: "支持 HarmonyOS 3.0 及以上",
      icon: "ri-smartphone-fill",
      url: "https://www.huangdoumogaiduanju.com",
    },
    {
      key: "windows",
      name: "Windows 版",
      shortName: "Windows",
      desc: "大屏追剧更爽，支持高清全屏播放",
      note: "支持 Windows 10 / 11",
      icon: "ri-computer-fill",
      url: "https://www.huangdoumogaiduanju.com",
    },
  ],
};